module.exports = __webpack_public_path__ + "static/img/0.c6aefbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fg/0.png
// module id = 125
// module chunks = 2